import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'
import { getCanonicalAffiliatePath } from '../utils/legacy-affiliate-url'

/**
 * Affiliate Path Redirect Middleware
 *
 * User-facing URL migration: legacy `/affiliate` and `/affiliate/*` document URLs receive
 * an HTTP 302 (replace) to `/affiliates` and `/affiliates/*` with query string and hash
 * preserved. See `legacy-affiliate-url.ts` for the full path contract table.
 *
 * Static assets under `/affiliate/*.(css|js)` never reach Nuxt — ingress serves them from
 * the affiliate GCS bucket — so this middleware only canonicalizes HTML/document routes.
 *
 * Runs on server and client so direct loads, refreshes, and SPA navigations stay canonical.
 */
export default defineNuxtRouteMiddleware(to => {
  const targetPath = getCanonicalAffiliatePath(to.path)
  if (!targetPath) {
    return
  }

  return navigateTo({ path: targetPath, query: to.query, hash: to.hash }, { replace: true, redirectCode: 302 })
})
